/*
 * Disclaimer
 *
 *
 */
const initDisclaimer = () => {
    const disclaimer = document.querySelector(".disclaimer");
    if (disclaimer) {
        const subscribeDisclaimer = document.getElementById("confirm-subscribe");
        const isConfirmed = sessionStorage.getItem("disclaimerConfirmation");
        if (!(isConfirmed === "confirmed")) {
            setTimeout(() => {
                //document.body.classList.add("disclaimer-open");
                disclaimer.classList.add("active");
            }, 2000);
            subscribeDisclaimer.addEventListener("click", () => {
                //document.body.classList.remove("disclaimer-open");
                disclaimer.classList.remove("active");
                sessionStorage.setItem("disclaimerConfirmation", "confirmed");
            });
        }
    }
};
